<template>
  <div class="time">
    <el-col :span="10">
      <el-date-picker
        v-model="startValue"
        type="datetime"
        :placeholder="startText"
        value-format="yyyy-MM-dd HH:mm:ss"
        :picker-options="pickerOptionsStart"
        :editable="false"
        default-time="06:00:00"
        @change="startChange"
      >
      </el-date-picker>
    </el-col>
    <el-col :span="1" style="margin-left:33px;">
      -
    </el-col>
    <el-col :span="10">
      <el-date-picker
        v-model="endValue"
        type="datetime"
        :placeholder="endText"
        :editable="false"
        value-format="yyyy-MM-dd HH:mm:ss"
        :picker-options="pickerOptionsEnd"
        align="right"
        default-time="12:00:00"
        @change="endChange"
      >
      </el-date-picker>
    </el-col>
  </div>
</template>

<script>
export default {
  name: "DatePicker",
  props: {
    startTime: {
      required: true,
    },
    endTime: {
      required: true,
    },
    startText: {
      type: String,
      required: false,
      default: "开始时间",
    },
    endText: {
      type: String,
      required: false,
      default: "结束时间",
    },
  },
  data() {
    return {
      startValue: this.startTime,
      endValue: this.endTime,
      pickerOptionsStart: {
        // 开始时间早于结束时间，且要早于当前日期
        disabledDate: (time) => {
          let endDateVal = this.endTime
          if(this.startText=='计划停电开始时间'){
            if (endDateVal) {
              return time.getTime() > new Date(endDateVal).getTime()
            } else {
              return false
            }
          }else{
            if (endDateVal) {
              return time.getTime() > new Date(endDateVal).getTime()
            } else {
              return time.getTime() > Date.now()
            }
          }
        }
      },
      pickerOptionsEnd: {
        // 结束时间要晚于开始时间，但是要早于当前日期
        disabledDate: (time) => {
          let beginDateVal = this.startTime
          // let endtime = ""
          if(this.endText=="计划停电结束时间"){
            if (beginDateVal) {
              return new Date(beginDateVal).getTime()-8.64e7 > time.getTime()
            } else {
              return false
            }
          }else{
            if (beginDateVal) {
              return new Date(beginDateVal).getTime()-8.64e7 > time.getTime() || time.getTime() > Date.now()
            } else {
              return time.getTime() > Date.now()
            }
          }
        }
      }
    }
  },
  watch: {
    startTime(newValue) {
      this.startValue = newValue
    },
    endTime(newValue) {
      this.endValue = newValue
    },
  },
  methods: {
    startChange(val) {
      this.$emit("changeStart", val)
    },
    endChange(val) {
      this.$emit("changeEnd", val)
    },
  },
}
</script>
